import { IActivityItemBase } from '../../models/activities';
import { IBookingBase } from '../../models/bookings';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateBookingProps {
  activityScheduleId: string;
  bookedDate: Date;
  bookingQueueId?: string;
  cpf?: string;
  description?: string;
  email: string;
  endTime?: Date;
  isActive?: boolean;
  isVerified?: boolean;
  items?: IActivityItemBase[];
  name: string;
  phone?: string;
  startTime?: Date;
}

export type INewBooking = IBookingBase;

export const createExternalLinkBookingsService = async ({
  activityScheduleId,
  bookedDate,
  bookingQueueId,
  cpf,
  description,
  email,
  endTime,
  isActive,
  isVerified,
  items,
  name,
  phone,
  startTime,
}: ICreateBookingProps): Promise<INewBooking> => {
  const { data } = await jhsfBookingsApi.post<INewBooking>(
    '/bookings/external-links',
    {
      activityScheduleId,
      bookedDate,
      bookingQueueId,
      cpf,
      description,
      email,
      endTime,
      isActive,
      items,
      name,
      phone,
      startTime,
    },
    { params: { isVerified } },
  );

  return data;
};
